import { FC } from 'react';
import { CircularProgress, Grid } from '@mui/material';

export type ProgressSize = 'small' | 'medium';

const SIZES: Record<ProgressSize, number> = {
  small: 25,
  medium: 40,
};

type Props = {
  progressSize?: ProgressSize;
};

/**
 *
 * @summary Компонент для отображения процесса загрузки.
 *
 * @description Компонент центрирован, то есть всегда будет
 * пытаться расположиться по центру родительского элемента.
 */
export const Loading: FC<Props> = ({ progressSize = 'medium' }) => (
  <Grid
    container
    justifyContent="center"
    alignItems="center"
    sx={{
      height: '100%',
    }}
  >
    <CircularProgress size={SIZES[progressSize]} />
  </Grid>
);
